import { Box, SvgIcon, Typography, Link } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import lock from '../../../assets/Images/lock.png';
import SectionTypeIcon from "../Icons/SectionTypeIcon";
import { COURSE_SECTION_TYPE_ID, ACTION_LABEL, renderTruncatedText } from "../../../core/Constant";

const VideoListView = ({
  icon,
  onclick,
  size,
  loked = 0,
  heading,
  content,
  link,
  onPreviewClick,
  contentType = 0,
  item,
  index,
  fileName,
  isExpired = false
}) => {
  const [progress, setProgress] = useState(false);
  const [locked, setLock] = useState(true)

  useEffect(() => {
    if (contentType !== COURSE_SECTION_TYPE_ID.VIDEO || contentType !== COURSE_SECTION_TYPE_ID.QUIZ) {
      setProgress(true);
    }
  }, []);

  useEffect(() => {
    setLock(item?.is_locked);
  }, [item])

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", alignSelf: "center" }}>
      {index === 0 && heading ? (
        <Box sx={{ display: "flex", alignItems: "center", width: "100%", mt: 2.5, mb: 1.5, pl: 1 }}>
          <Box
            sx={{
              border: "1.5px solid #cbd5e1",
              borderRadius: "24px",
              px: 2.5,
              py: 0.5,
              backgroundColor: "#ffffff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                color: "#1e293b",
                fontWeight: 700,
                fontFamily: "'Montserrat', sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              Day {heading}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, height: "1.5px", backgroundColor: "#e2e8f0", ml: 2 }} />
        </Box>
      ) : null}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          py: 1.25,
          pl: { xs: 1.5, sm: 6 },
          pr: 1,
          borderRadius: "8px",
          transition: "background-color 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "rgba(152, 52, 240, 0.03)",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0, mr: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2, flexShrink: 0 }}>
            {Object.values(COURSE_SECTION_TYPE_ID).includes(contentType) ? (
              <SectionTypeIcon contentType={contentType} fileName={fileName ?? content}
                sx={{ marginRight: 0, width: "35px", height: "35px" }} />
            ) : (
              <SvgIcon sx={{ marginRight: 0, width: "30px", height: "30px" }}>
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="100%" height="100%" rx="50" fill="#28B882" />
                  <path
                    d="M80.4343 34.0572L36.9561 77.5354L17.0286 57.6079L22.1373 52.4992L36.9561 67.2818L75.3256 28.9485L80.4343 34.0572Z"
                    fill="white"
                  />
                </svg>
              </SvgIcon>
            )}
          </Box>

          <Box
            sx={{
              width: 5,
              height: 5,
              borderRadius: "50%",
              backgroundColor: "#94a3b8",
              mr: 2,
              flexShrink: 0
            }}
          />

          <Typography
            sx={{
              fontSize: "15px",
              color: "#334155",
              fontWeight: 500,
              fontFamily: "'Montserrat', sans-serif",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1,
            }}
          >
            {renderTruncatedText(content, { limit: 60 })}
          </Typography>
        </Box>

        {((!locked) || loked) && !isExpired ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexShrink: 0, ml: 1 }}>
            <Link
              component="button"
              onClick={onPreviewClick}
              sx={{
                textDecoration: "none",
                "&:hover": {
                  "& .action-text": {
                    textDecoration: "underline",
                  }
                }
              }}
            >
              <Typography
                className="action-text"
                sx={{
                  fontSize: "14px",
                  color: "rgb(152, 52, 240)",
                  fontWeight: 600,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                {ACTION_LABEL[contentType] || "Completed"}
              </Typography>
            </Link>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexShrink: 0, ml: 1 }}>
            <img
              style={{ width: "20px", height: "20px", opacity: 0.7 }}
              src={lock}
              alt="locked"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default VideoListView;
